import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/challanEntrySlice"



const ChallanEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  const [tradeOf, setTradeOf] = useState()
  const [billType, setBillType] = useState()
  const [entryLabel, setEntryLabel] = useState("")
  const { challnid, challntype } = useParams();

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)

    const params = [SALE_PUR_ENTRY_TYPE.GrayCloth, SALE_PUR_ENTRY_TYPE.Yarn, SALE_PUR_ENTRY_TYPE.Millgin, SALE_PUR_ENTRY_TYPE.General]
    const paramtype = [CHALLAN_TYPE.Sale, CHALLAN_TYPE.Purchase]
    if (!params.includes(String(challnid)) || !paramtype.includes(String(challntype)))
      navigate(linksUrl.dashboard.tradingDashboard)


    disapatch(resetDetailParams())

    if (challnid && challnid != "") {
      let t_tradeof = ''
      let t_billtype = ''
      let t_entryLabel = ''
      let t_challnid = challnid.toLowerCase()
      let t_challntype = challntype.toLowerCase()
      if (t_challntype == CHALLAN_TYPE.Sale) {
        t_billtype = 'S'
        if (t_challnid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
          t_tradeof = 'C'
          t_entryLabel = "Gray Cloth Sale Challan"
        }
        else if (t_challnid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
          t_tradeof = 'Y'
          t_entryLabel = "Yarn Sale Challan"
        }
      }
      if (t_challntype == CHALLAN_TYPE.Purchase) {
        t_billtype = 'P'
        if (t_challnid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
          t_tradeof = 'C'
          t_entryLabel = "Gray Cloth Purchase Challan"
        }
        else if (t_challnid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
          t_tradeof = 'Y'
          t_entryLabel = "Yarn Purchase Challan"
        }
      }


      setTradeOf(t_tradeof)
      setBillType(t_billtype)
      setEntryLabel(t_entryLabel)
      funFilterData(t_tradeof, t_billtype);
    }
  }, [challnid])



  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.transaction.challanEntry.fetch,
    queryKey: "Challan Data List",

  })
  const funFilterData = (trade, billtype) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        tradeof: String(trade),
        billtype: billtype
      }
    })

  }


  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData(tradeOf, billType);
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.transaction.challanEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "net_amount",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "party_name",
    //"vou_no",
    "chal_no",
    "net_amount",
    "chal_date",
    "account_name",

  ]

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "CHAL NO",
      uid: "chal_no",
    },
    {
      name: "AMOUNT",
      uid: "net_amount",
    },
    {
      name: "DATE",
      uid: "chal_date",
      type:COLUMN_TYPE.date
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },
  ]

  let downloadDataFooter = {
    party_name: "",
    chal_no: "",
    net_amount: "Total: " + totalAmt,
    chal_date: "",
    account_name: "",
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "CHAL NO",
      uid: "chal_no",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "net_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "DATE",
      uid: "chal_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          transaction_id: itemToDelete.transaction_id,
          comp_code: itemToDelete.comp_code,
          chalno: itemToDelete.chal_no,
          inward_type: billType,
          bill_type: itemToDelete.bill_type
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          comp_code: row.compcode,
          transaction_id: row.transaction_id,
          bill_type: billType

        }
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.transaction.ChallanEntry + challntype + "/" + challnid + "/create-entry")
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToDelete({ transaction_id: row.transaction_id, comp_code: row.compcode, chal_no: row.chal_no, bill_type: row.bill_type })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.transaction.ChallanEntry + challntype + "/" + challnid + "/create-entry")
  }


  return (
    <div>

      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName={entryLabel}
        info={[]}
        breadcrumbs={[ billType=="S"?"Sales":"Purchase" , entryLabel]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="challan-List"
          showAdvanceFilter={false}
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default ChallanEntryMaster
